module.exports = __webpack_public_path__ + "img/118D-1.27.086cee9e.png";